'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-list.routes';

export class SurveyListComponent {
  constructor(Auth, SurveysService, dialogs, $uibModal, $stateParams, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.SurveysService = SurveysService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;
    this.Config = Config;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.formName = $stateParams.name;

    this.SurveysService.query((data) => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve surveys.")
    })
  }

  copyToClipboard(survey) {
    let path = "/survey/" + survey._id;

    if (survey.isPublic)
      path = this.Config.getPlatformConfig().getBaseUrl() + "/public/survey/" + survey._id;

    window.prompt("Link to Survey:", path);
  }

  delete(survey) {
    var that = this;

    var surveyText = "<br/><br/><b>"+survey.name+"</b><br/><p>" + survey.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Survey?", "Do you really want to delete the following survey and all its responses?" + surveyText);
    dlg.result.then(() => {
      // OK delete it
      that.SurveysService.delete({id: survey._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== survey._id;
          });
        },
        err => {
          alert("Could not delete survey");
        });
    }, () => {
      // Cancel
    });
  }

  /*
  openPreviewModal(eform) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'jsonViewer',
      resolve: {
        config: function() {
          return {
            data: eform.data
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () {  },
      function () {  }
    );

  }*/
}

export default angular.module('conduu.surveyList', [uiRouter])
  .config(routes)
  .component('surveyList', {
    template: require('./survey-list.html'),
    controller: SurveyListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/list/survey-list.component.js